import React from "react";
import BulkUpload from "../../../components/BulkUpload/BulkUpload";
const BulkUploadPage = () => {
  return <BulkUpload />;
};

export default BulkUploadPage;
